module.exports = __webpack_public_path__ + "media/icons/checkmark-black-1a6f87c4.png";